import getters from '@/store/spWorkerRegistration/getters';
import mutations from '@/store/spWorkerRegistration/mutations';
// eslint-disable-next-line import/no-cycle
import actions from '@/store/spWorkerRegistration/actions';

const state = {
  spWorkerServicesChosen: [],
  spWorkerCertificationsChosen: [],
  spWorkerGeneralInfo: {},
  spWorkerAvatar: null,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
